<th colspan="4" class="text-end py-1">
    <ng-container *ngTemplateOutlet="side; context: {side: HomeSide}"></ng-container>
</th>

<th class="text-center px-0 py-1">    
    @if(againstGame().getState() === Finished) {        
        <span class="text-nowrap">{{s11NameService.getAgainstScore(againstGame())}}</span>
    } @else {        
        <div class="text-nowrap">
            <small>
                @let dateTitle = dateFormatter.toString(againstGame().getStartDateTime(),dateFormatter.dateWithWeekday());
                {{dateTitle}}
            </small>
        </div>
        <div class="text-nowrap">
            <small>
                @let timeTitle = dateFormatter.toString(againstGame().getStartDateTime(),dateFormatter.time());
                {{timeTitle}}
            </small>
        </div>
    }
</th>

<th colspan="4" class="py-1">
    <ng-container *ngTemplateOutlet="side; context: {side: AwaySide}"></ng-container>
</th>

<ng-template #side let-side="side">
    @let sideCompetitor = sportExtensions.getCompetitor(againstGame(), side);
    @if(sideCompetitor) {
        @let team = getTeam(sideCompetitor);
        @if(team){
            <div class="w-100" [ngClass]="{'align-self-end': side == HomeSide}">
                @if(isTeamCompetitor(sideCompetitor)) {
                    <app-team-name [team]="team" [fullName]="true" [reverse]="side == HomeSide">
                    </app-team-name>
                }
                
            </div>
        }
    }
</ng-template>
